/**
 * Stable CSS class names for E2E — Redis cache management page.
 */
export const RCM = {
    page: 'redis-cache-management-page',
    headerSection: 'redis-cache-management-page__header-section',
    title: 'redis-cache-management-page__title',
    description: 'redis-cache-management-page__description',

    filterSection: 'redis-cache-management-page__filter-section',
    filterPaper: 'redis-cache-management-page__filter-paper',
    filterGrid: 'redis-cache-management-page__filter-grid',
    inputDatabaseNumber: 'redis-cache-management-input--database-number',
    inputKeySearch: 'redis-cache-management-input--key-search',
    buttonFilter: 'redis-cache-management-input--button-filter',
    buttonClear: 'redis-cache-management-input--button-clear',

    loadingSection: 'redis-cache-management-page__loading-section',
    loadingSpinner: 'redis-cache-management-page__loading-spinner',
    loadingText: 'redis-cache-management-page__loading-text',

    errorSection: 'redis-cache-management-page__error-section',
    errorAlert: 'redis-cache-management-page__error-alert',

    keysSection: 'redis-cache-management-page__keys-section',
    keysPaper: 'redis-cache-management-page__keys-paper',
    keysHeaderRow: 'redis-cache-management-page__keys-header-row',
    keysTitle: 'redis-cache-management-page__keys-title',
    keysActions: 'redis-cache-management-page__keys-actions',
    selectAllControl: 'redis-cache-management-input--select-all',
    buttonBulkDelete: 'redis-cache-management-input--button-bulk-delete',

    dataGridOuter: 'redis-cache-management-page__data-grid-outer',
    dataGridWrap: 'redis-cache-management-page__data-grid-wrap',

    cellSelectCheckbox: 'redis-cache-management-input--checkbox-select-key',
    cellKey: 'redis-cache-management-page__cell-key',
    cellTtl: 'redis-cache-management-page__cell-ttl',
    cellDeleteButton: 'redis-cache-management-input--button-delete-key',

    emptyState: 'redis-cache-management-page__empty-state',
    emptyText: 'redis-cache-management-page__empty-text',
} as const;

export const rcmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

